export const isSolarGenerationEmpty = (getValues: any) => {
  const billFrequency = getValues("billFrequency");
  const winterExport = Number(getValues("winterGeneration"));
  const summerExport = Number(getValues("summerGeneration"));

  return (
    winterExport === 0 ||
    summerExport === 0 ||
    typeof billFrequency === "undefined"
  );
};
